import React from "react";
import { Header } from "../Header";
import { Footer } from "../Footer";
import line from "../../assests/Group 1870 line2.png";
import lwr1 from "../../assests/lwrstorysan1.png";
import lwr2 from "../../assests/lwrstoryphilip1.png";
import lwr3 from "../../assests/lwrstoryphilps2.png";

import { Link } from "react-router-dom";
import { useEffect } from "react";
import axios from 'axios';
import { useState } from "react";
// import {
//   FacebookShareButton,
//   WhatsappShareButton,
//   TwitterShareButton,
// } from "react-share";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
} from "react-share";

import CopyToClipboard from "react-copy-to-clipboard";


function LWRstory() {
  const [urlToCopy, setURLToCopy] = useState("");
  const shareOnWhatsApp = () => {
    const text = "Check out this amazing story: LWR";
    const url = "https://lovewithoutreason.org/LWRstory";
    const image = "https://lovewithoutreason.org/static/media/founder1.62ee5d556b3401b75be9.png"; // Replace with the URL of your image
  
    const shareLink = `whatsapp://send?text=${encodeURIComponent(`${text}\n${url}`)}`;
  
    // Open the WhatsApp share dialog
    window.location.href = shareLink;
  };
  const handleCopy = () => {
    setURLToCopy("Copied");
  };
  console.log("urlToCopy", urlToCopy);
  // useEffect(() => {
  //   const hash = window.location.hash;

  //   if (hash) {
  //     const targetId = hash.slice(1);

  //     const targetElement = document.getElementById(targetId);

  //     if (targetElement) {
  //       targetElement.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   }
  // }, []);
  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);
  const [mailData, setMaildata] = useState({
    firstname: '',
    lastname: '',
    number: '',
    email: '',
    message: ''
  });

  const userDetails = (e) => {
    const { name, value } = e.target;
    setMaildata({ ...mailData, [name]: value });
  }

  const sendEmail = async (e) => {
    e.preventDefault();
    const payload = {
      service_id: 'service_tt2kz7w',
      template_id: 'template_d0upv0l',
      user_id: 'ppekGscEBiOpBosKz',
      template_params: {
        'firstname': mailData.firstname,
        'lastname': mailData.lastname,
        'number': mailData.number,
        'email': mailData.email,
        'message': mailData.message
      }
    }
    axios.post('https://api.emailjs.com/api/v1.0/email/send', JSON.stringify(payload), {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      alert(res.data === 'OK' ? 'Thank you for contacting Love Without Reason. We appreciate your kindness generosity and support.  One of our team members will contact you as soon as possible.' : '');
      setTimeout(() => {
        window.location.reload()
      }, 1000)

    }).catch((err) => {
      alert('Failed to Submit')
      console.log(err);
    })

  };
  return (
    <>
      <Header />

      <section className="mt-5" style={{ minHeight: "100vh" }}>
        <div className="container">
          <div className="row d-flex justify-content-center">
            < div className="col-md-4 mt-5 text-center ">
              <img src={lwr1} className="img-fluid" />
              <h4 className="text-uppercase fw-bolder">Santhosh Mathews</h4>
              <h5 className="text-uppercase fw-bolder text-danger">FOUNDER - LOVE WITHOUT REASON</h5>

            </div>

            <div className="col-md-6 mt-5">
              <div className="row mt-5">
                <div className="col-md-4">
                  <h3 className="fw-bolder border-bottom  border-4 border-danger">LWR STORY</h3>
                </div>
              </div>
              <p className="india-text mt-2">
                Seated on a couch one December afternoon in 2006, feeling sorry for myself for having lost a great job, I began to question God. What is the purpose of my life?<br /><br />
                Why do I even exist? <br /><br />
                I am a failure and a shame to my family and to my community. <br /><br />
                Why am I alive? The easiest thing would be to just end it right here.
              </p>
            </div>
          </div>

          <div className="row d-flex justify-content-center mt-4">
            <div className="col-md-6">
              <p className="india-text">
                The questions were endless as I flipped through the channels on our TV looking for an answer. Suddenly I saw a familiar sight – A little girl with a cleft lip. My channel surfing took me to one of the local TV stations airing the 700 Club. The narrator was describing the story of this 9 year old girl from Indonesia, born with a cleft lip and palate. This girl looked different, was unable to speak properly and obviously not “normal.” So she was considered an outcast or a curse because of her deformity. Apparently because of her inability to communicate she would throw tantrums when she felt that her needs were not met.
              </p>
            </div>
            <div className="col-md-4">
              <img src={lwr2} className="img-fluid mt-3" />
            </div>
          </div>

          <div className="row d-flex justify-content-center mt-3">
            <div className="col-md-10">
              <p className="india-text">During one such episode the villagers decided to teach her a lesson and tied her to a tree and took turns beating her. Soon the girl fell unconscious and was left to die. A missionary who went by that village saw the girl and took her to the hospital and treated her. The missionary also found surgeons who could repair her lip and palate. Eventually a new home was found for her.</p>
            </div>
          </div>

          <div className="row d-flex justify-content-center mt-3">
            <div className="col-md-3 mt-3">
              <img src={lwr3} className="img-fluid" />

            </div>
            <div className="col-md-7">
              <p className="india-text">
                The before and after pictures of this “cursed” girl riveted me to my seat; because that girl could have been my own son, Philip Mathews, who was born with Goldenhar syndrome in the year 2000. Philip was born with a cleft lip, cleft palate, absent right eye and right ear, multiple holes in his heart and had many developmental problems. We were told that he would be born dead because they could not find a stomach in him. “No Hope” was what the doctors told us, “there is no hope that this baby will be born alive.” We were told to abort our child. But we held on to our faith and the Lord rewarded us with a blessed baby boy. Many miracles and more than 23 surgeries and procedures later, Philip has turned out to be an amazing young man with a powerful testimony to tell. Even with all the deformities, Philip was a blessing and the source of great joy in our family.
              </p>
            </div>
          </div>

          <div className="row d-flex justify-content-center mt-3">
            <div className="col-md-10">
              <p className="india-text">
                To think that a baby like him would be considered cursed and beaten for an inability to communicate broke my heart. I remember weeping for that girl and just asking God why this was so.
                Suddenly I understood my calling. In very clear terms God showed me the path that my wife and I went through over the past several years in caring for Philip and what He wanted us to do into the future. I knew instantly that my purpose and mission was to find children like Philip and this 9 year old girl from Indonesia and help them with free craniofacial surgeries and holistic care.</p>
              <p className="india-text">The story still continues through the life of our patients, partners, friends, donors and friends. 
                Join us as we continue to write this story upto until the world is cleft-free..!</p>
            </div>
          </div>


          <div className='row  d-flex justify-content-center mb-5'>
            <div class='col-md-6'>
              <div class='card shadow border-0 text-center rounded mt-3'>
                <iframe className='rounded' style={{ minHeight: '50vh', width: '100%' }} src="https://www.youtube.com/embed/SJEVCz7Jd-o?si=BWDc2l_L8z4b_Jk3" title="PHILIP MATHEWS - LIFESTORY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen="allowfullscreen"
                  mozallowfullscreen="mozallowfullscreen"
                  msallowfullscreen="msallowfullscreen"
                  oallowfullscreen="oallowfullscreen"
                  webkitallowfullscreen="webkitallowfullscreen"></iframe>
                <div class="card-body border-0">
                  <h4 classname="text-dark fw-bold">Envisioning a World Cleft-Free</h4>
                </div>
              </div>
            </div>
            </div>

          <div className="row d-flex justify-content-center">
            <div className="col-md-2 mb-3">
              <button
                type="button"
                class="btn btn-danger w-75 "
                data-bs-toggle="modal"
                data-bs-target="#staticBackdropindia16"
              >
                Share <i class="fa-solid fa-share"></i>
              </button>
            </div>
            <div
              class="modal fade "
              id="staticBackdropindia16"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                  <div class="modal-header p-3">
                    <h5
                      class="modal-title fw-bolder text-dark"
                      id="staticBackdropLabel"
                    >
                      LWR STORY
                    </h5>
                    <button
                      type="button"
                      class="btn-close border"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-12">
                        <a href="https://www.facebook.com/login/">
                          <FacebookShareButton
                            url={
                              "https://lovewithoutreason.org/LWRstory"
                            }
                            quote={"LWR"}
                            hashtag="#lovewithoutreason"
                            image={"https://lovewithoutreason.org/static/media/founder1.62ee5d556b3401b75be9.png"} 
                          >
                            <i class="fa-brands fa-square-facebook fa-2x m-1 text-primary"></i>
                          </FacebookShareButton>
                        </a>
                        <a href="https://www.whatsapp.com/">
                          <WhatsappShareButton
                            url={
                              "https://lovewithoutreason.org/LWRstory"
                            }
                            quote={"LWR"}
                            hashtag="#lovewithoutreason"
                            image={"https://lovewithoutreason.org/static/media/founder1.62ee5d556b3401b75be9.png"} 
                          >
                            <i class="fa-brands fa-square-whatsapp fa-2x m-1 text-success"></i>
                          </WhatsappShareButton>
                        </a>
                        
                        <a href="https://twitter.com/">
                          <TwitterShareButton
                            url={
                              "https://lovewithoutreason.org/LWRstory"
                            }
                            quote={"LWR"}
                            hashtag="#lovewithoutreason"
                          >
                            <i class="fa-brands fa-square-x-twitter  fa-2x m-1 text-dark"></i>

                          </TwitterShareButton>
                        </a>

                        {/* <i className="fa fa-clone fa-3x m-1" style={{ color: "#C3C4C4" }}></i> */}
                        <a href="https://www.linkedin.com/">
                          <LinkedinShareButton
                            url={"https://lovewithoutreason.org/LWRstory"}
                            title={"LWR"}
                            summary={"https://lovewithoutreason.org/"}
                            source={"#lovewithoutreason"}
                          >

                            <i className="fa-brands fa-linkedin fa-2x m-1 text-info"></i>
                          </LinkedinShareButton>
                        </a>
                        <CopyToClipboard
                          text={
                            "https://lovewithoutreason.org/LWRstory"
                          }
                          onCopy={handleCopy}
                        >
                          <i
                            className="fa fa-clone fa-2x m-1"
                            style={{ color: "#C3C4C4" }}
                          ></i>
                        </CopyToClipboard>
                        <p style={{ fontSize: "8px", textAlign: "end" }}>
                          {urlToCopy !== "" ? urlToCopy : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2 mb-3">
              <Link to="/DonateIndia" target="_top">
                <button class="btn btn-danger w-75">
                  Donate <i class="fas fa-duotone fa-hand-holding-heart"></i>
                
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default LWRstory;
